<script>
import SongDetailContent from "../components/SongDetailContent.vue";

export default {
  name: "SongView",
  components: { SongDetailContent },
  props: {
    config: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
};
</script>

<template>
  <song-detail-content :config="config" :show-chrome="true" :show-actions="true" />
</template>
